import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareMinus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareMinus"><Path d="M20.5 3.5H21V3H20.5V3.5ZM20.5 20.5V21H21V20.5H20.5ZM3.5 20.5H3V21H3.5V20.5ZM3.5 3.5V3H3V3.5H3.5ZM15.4926 12.5H15.9926V11.5H15.4926V12.5ZM8.50736 11.5H8.00736V12.5H8.50736V11.5ZM20 3.5V20.5H21V3.5H20ZM20.5 20H3.5V21H20.5V20ZM4 20.5V3.5H3V20.5H4ZM3.5 4H20.5V3H3.5V4ZM15.4926 11.5H8.50736V12.5H15.4926V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareMinus;
